import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { useState, forwardRef, useEffect } from 'react';
import languageData from '../../config/WeglotLanguageTranslation.json';
import 'dayjs/locale/fr';
import 'dayjs/locale/es';
import 'dayjs/locale/en';
import 'dayjs/locale/nl';
import 'dayjs/locale/de';
import 'dayjs/locale/pt';
import 'dayjs/locale/ru';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/ko';
import 'dayjs/locale/it';
import 'dayjs/locale/bg';
import 'dayjs/locale/hr';
import 'dayjs/locale/tr';
import 'dayjs/locale/da';
import 'dayjs/locale/sv';
import 'dayjs/locale/cs';
import 'dayjs/locale/he';
import 'dayjs/locale/ga';
import 'dayjs/locale/sk';
import 'dayjs/locale/th';
import 'dayjs/locale/uk';
import 'dayjs/locale/nb';
import 'dayjs/locale/fa';
import 'dayjs/locale/el';
import 'dayjs/locale/fi';
import 'dayjs/locale/bs';
import 'dayjs/locale/pl';
import 'dayjs/locale/sl';
import 'dayjs/locale/ja';
import 'dayjs/locale/ar';



const DateTranslatedPicker = forwardRef((props, ref) => {
  
  const [languageCodeData, ] = useState(languageData);
  const [languageCode, setLanguageCode] = useState()
  
  const handleData = (event, id, type) => {
    props.handleSearch(event, id, type)
        
  };

  useEffect(()=>{
    var localLanguageCode = languageCodeData?.calendarLocales[window.Weglot.getCurrentLang()]        
        
        if(localLanguageCode !== undefined)
        {
            setLanguageCode(localLanguageCode?.dayjs_locale)    
        }
        else{
            setLanguageCode("en")    
        }    
  },[])

  window.Weglot.on("languageChanged", function languageChanger(newLang, prevLang) {        
        
    var localLanguage = languageCodeData?.calendarLocales[newLang];
    
    
    if(localLanguage !== undefined)
    {
        setLanguageCode(localLanguage?.dayjs_locale)    
    }
    else{
        setLanguageCode("en")    
    }                 
               
})

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={languageCode}>
    <DatePicker
      id={props.id}
      label={props.label}
      slotProps={{ textField: { fullWidth: true, size: "small" } }}
      views={["year", "month", "day"]}
      maxDate={dayjs(props.maxDate || '')}
      minDate={dayjs(props.minDate || '')}
      name={props.name}
      value={props.value ? dayjs(props.value) : null}
      onChange={(event) => handleData(event, props.name, "date")}
      className={props.className}
      InputLabelProps={{ style: { color: "black" } }}
    />
    </LocalizationProvider>
  );
})
export default DateTranslatedPicker;
